import { gql } from '@apollo/client';

export const QUERY_PARENTS = gql`
    query parents (
        $filters: ParentFiltersInput,
    ) {
        parents(filters: $filters) {
            data {
                id
                attributes {
                    firstName
                    lastName
                    account {
                        data {
                            id
                            attributes {
                                contacts {
                                    type
                                    value
                                    data
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const UPDATE_PARENT = gql`
    mutation updateParent ($data: ParentInput!, $id: ID!) {
        updateParent(data: $data, id: $id) {
            data {
                id
            }
        }
    }
`;